export interface IConsentRequest {
  type: string;
}

export type IConsentResponse = boolean;

export enum IConsentType {
  CAPITAL_EXPLORER = "capital_explorer",
}
